import React from 'react'
import PropTypes from 'prop-types'
import { ButtonToolbar } from 'reactstrap'
import { BOARDING_GROUP_PATH } from '../../../../../config/paths'
import EditButton from '../../../../common/button/EditButton'

const BoardingGroupToolbar = ({
  boardingGroupId,
}) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${BOARDING_GROUP_PATH}/${boardingGroupId}/edit`} />{' '}
    </div>
  </ButtonToolbar>
)

export default BoardingGroupToolbar

BoardingGroupToolbar.propTypes = {
  boardingGroupId: PropTypes.string.isRequired,
}